import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Documento, ListadoDocumentoPaginado, NumeracionDocumento, RecorridoDocumento, TramitePortal } from '../models/Document';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DocumentoService {

  private URL_NUMERACION = environment.apiUrl + "nd"
  private POST_TRAMITE_URL = environment.apiUrl + "portal/d"
  private PATCH_TRAMITE_URL = environment.apiUrl + "portal/d/"
  private ALCANCE_TRAMITE_URL = environment.apiUrl + "ta/al/"
  private GET_LISTADO_DOCUMENTOS_BANDEJA = environment.apiUrl + "portal/l/b/"
  private GET_LISTADO_DOCUMENTOS_REASIGNADOS = environment.apiUrl + "portal/l/r"
  private GET_LISTADO_DOCUMENTOS_ARCHIVADOS = environment.apiUrl + "portal/l/a"
  private GET_LISTADO_DOCUMENTOS_IMPRESOS = environment.apiUrl + "portal/l/i"
  private GET_DOCUMENTOS_BUSQUEDA_AVANZADA = environment.apiUrl + "portal/l/b"
  private DELETE_DOCUMENTO = environment.apiUrl + "portal/d/"
  private GET_RECORRIDO_DOCUMENTO = environment.apiUrl + "portal/d/r/"
  private PATCH_CERRAR_DOCUMENTO = environment.apiUrl + "portal/d/c/"

  constructor(
    private http: HttpClient
  ) { }

  getById(id: number): Observable<Documento[] | any> {
    return this.http.get<Documento[]>(environment.apiUrl + "doc/" + id);
  }

  postTramite(tramite: TramitePortal): Observable<TramitePortal> {
    return this.http.post<TramitePortal>(this.POST_TRAMITE_URL, tramite)
  }

  patchTramite(tramite: TramitePortal): Observable<TramitePortal> {
    return this.http.patch<TramitePortal>(this.PATCH_TRAMITE_URL + tramite.id!, tramite)
  }

  respuestaAlcanceTarea(tramite: TramitePortal, alcanceMode: boolean): Observable<TramitePortal> {
    if (alcanceMode) {
      return this.http.post<TramitePortal>(this.ALCANCE_TRAMITE_URL + tramite.id!, tramite)
    }
    return this.patchTramite(tramite)
  }

  getListadoDocumentosBandeja(
    tipoBandeja: string,
    fechaInicio: string,
    fechaFin: string,
    busqueda: string | null,
    tipoDocumento: number | null,
    idBuzon: number | null,
    numero: string | null,
    pagina: number
  ): Observable<ListadoDocumentoPaginado> {
    let params = new HttpParams();

    params = params.set('fi', fechaInicio);
    params = params.set('ff', fechaFin);
    if (busqueda) {
      params = params.set('b', busqueda);
    }
    if (tipoDocumento !== null && tipoDocumento !== undefined && tipoDocumento > 0) {
      params = params.set('td', tipoDocumento);
    }
    
    if (idBuzon !== null && idBuzon !== undefined && idBuzon > 0) {
      params = params.set('buzon', idBuzon);
    }
    params = params.set('p', pagina);
    if (numero !== null && numero !== undefined && numero !== "") {
      params = params.set('nf', numero);
    }

    return this.http.get<ListadoDocumentoPaginado>(
      this.GET_LISTADO_DOCUMENTOS_BANDEJA + tipoBandeja,
      { params }
    );
  }

  getListadoDocumentosReasignados(
    fechaInicio: string,
    fechaFin: string,
    busqueda: string | null,
    tipoDocumento: number | null,
    pagina: number
  ): Observable<ListadoDocumentoPaginado> {
    let params = new HttpParams();

    params = params.set('fi', fechaInicio);
    params = params.set('ff', fechaFin);
    if (busqueda) {
      params = params.set('b', busqueda);
    }
    if (tipoDocumento !== null && tipoDocumento !== undefined && tipoDocumento > 0) {
      params = params.set('td', tipoDocumento);
    }
    params = params.set('p', pagina);


    return this.http.get<ListadoDocumentoPaginado>(
      this.GET_LISTADO_DOCUMENTOS_REASIGNADOS,
      { params }
    );
  }

  getListadoDocumentosArchivados(
    fechaInicio: string,
    fechaFin: string,
    busqueda: string | null,
    tipoDocumento: number | null,
    pagina: number
  ): Observable<ListadoDocumentoPaginado> {
    let params = new HttpParams();

    params = params.set('fi', fechaInicio);
    params = params.set('ff', fechaFin);
    if (busqueda) {
      params = params.set('b', busqueda);
    }
    if (tipoDocumento !== null && tipoDocumento !== undefined) {
      params = params.set('td', tipoDocumento);
    }
    params = params.set('p', pagina);


    return this.http.get<ListadoDocumentoPaginado>(
      this.GET_LISTADO_DOCUMENTOS_ARCHIVADOS,
      { params }
    );
  }

  getListadoAdmDocumentos(
    fechaInicio: string,
    fechaFin: string,
    busqueda: string | null,
    usuario: number | null,
    pagina: number
  ): Observable<ListadoDocumentoPaginado> {
    let params = new HttpParams();

    params = params.set('fi', fechaInicio);
    params = params.set('ff', fechaFin);
    if (busqueda) {
      params = params.set('b', busqueda);
    }
    params = params.set('p', pagina);


    return this.http.get<ListadoDocumentoPaginado>(environment.apiUrl + "a/lu/" + usuario, { params });
  }


  getListadoDocumentosImpresos(
    fechaInicio: string,
    fechaFin: string,
    busqueda: string | null,
    tipoDocumento: number | null,
    pagina: number
  ): Observable<ListadoDocumentoPaginado> {
    let params = new HttpParams();

    params = params.set('fi', fechaInicio);
    params = params.set('ff', fechaFin);
    if (busqueda) {
      params = params.set('b', busqueda);
    }
    if (tipoDocumento !== null && tipoDocumento !== undefined) {
      params = params.set('td', tipoDocumento);
    }
    params = params.set('p', pagina);


    return this.http.get<ListadoDocumentoPaginado>(
      this.GET_LISTADO_DOCUMENTOS_IMPRESOS,
      { params }
    );
  }

  getDocumentosBusquedaAvanzada(
    numeroDocumento: string | null,
    numeroReferencia: string | null,
    fechaInicio: string,
    fechaFin: string,
    busqueda: string | null,
    tipoDocumento: number | null,
    anio: number | null,
    numero: number | null,
    de: string | null,
    para: string | null,
    copia: string | null,
    pagina: number
  ): Observable<ListadoDocumentoPaginado> {
    let params = new HttpParams();

    if (fechaInicio) {
      params = params.set('fi', fechaInicio);
    }
    if (fechaFin) {
      params = params.set('ff', fechaFin);
    }

    if (numero && anio) {
      params = params.set('numeroTramite', anio + "-" + numero);
    }

    if (de) {
      params = params.set('remitente', de);
    }

    if (para) {
      params = params.set('destinatario', para);
    }

    if (copia) {
      params = params.set('copia', copia);
    }

    if (numeroDocumento) {
      params = params.set('numeroOficio', numeroDocumento);
    }
    if (numeroReferencia) {
      params = params.set('nr', numeroReferencia);
    }
    if (busqueda) {
      params = params.set('asunto', busqueda);
    }
    if (tipoDocumento !== null && tipoDocumento !== undefined && tipoDocumento != -1) {
      params = params.set('td', tipoDocumento);
    }
    params = params.set('p', pagina);


    return this.http.get<ListadoDocumentoPaginado>(
      this.GET_DOCUMENTOS_BUSQUEDA_AVANZADA,
      { params }
    );
  }

  delete(id: number, observation: string): Observable<string> {
    return this.http.delete(this.DELETE_DOCUMENTO + id, {
      responseType: 'text',
      params: {
        "obs": observation
      }
    });
  }

  getDocumentRoute(id: number): Observable<RecorridoDocumento[]> {
    return this.http.get<RecorridoDocumento[]>(this.GET_RECORRIDO_DOCUMENTO + id)
  }

  getDocumentos(anio: string, numero: string): Observable<Documento[]> {
    return this.http.get<Documento[]>(environment.apiUrl + "tramite/" + anio + "/" + numero);
  }

  getGrafico(idTarea: number): Observable<any> {
    return this.http.get<any>(environment.apiUrl + "grafico/" + idTarea)
  }

  getFirmasList(): Observable<any> {
    return this.http.get(environment.apiUrl + "f/cust");
  }

  signDocumento(id: number, data: any): Observable<string> {
    return this.http.put(environment.apiUrl + "an/f/" + id, data, { responseType: "text" });
  }

  cerrarDocumento(id: number): Observable<string> {
    return this.http.patch(this.PATCH_CERRAR_DOCUMENTO + id, null, { responseType: "text" })
  }

  /**
   * Marca un documento como leído
   * @param id id de la tarea
   * @returns Observable<string>
   */
  marcarLeido(id: number): Observable<string> {
    return this.http.patch(environment.apiUrl + "doc/" + id + "/leido", null, {
      responseType: "text"
    });
  }

  /**
  * Marca un documento como leído
  * @param id id de la tarea
  * @param estado Estado de importancia
  * @returns Observable<string>
  */
  marcarImportancia(id: number, estado: number): Observable<string> {
    return this.http.patch(environment.apiUrl + "doc/" + id + "/i/" + estado, null, {
      responseType: "text"
    });
  }

  /**
   * Obtiene la numeracion por defecto del usuario
   * @param id id del usuario
   * @returns Numeraciones
   */
  getNumeracion(id?: string): Observable<NumeracionDocumento[]> {
    return this.http.get<NumeracionDocumento[]>(this.URL_NUMERACION + "/user/" + id);
  }

  /**
   * Obtiene un listado de numeraciones del departamento del usuario
   * @param id id del usuario
   * @returns Numeraciones
   */
  getNumeraciones(id?: string): Observable<NumeracionDocumento[]> {
    return this.http.get<NumeracionDocumento[]>(this.URL_NUMERACION + "/user/" + id + "/l");
  }

}
